import { useMemo } from "react";
import { useGetList } from "ra-core";
import type { OrganizationMember } from "@/components/atomic-crm/types";
import { getMemberName } from "@/components/atomic-crm/tasks/taskMemberOptions";

/** Team member names by id (authors of notes and activity). */
export const useMemberNames = () => {
  const { data: members = [] } = useGetList<OrganizationMember>(
    "organization_members",
    {
      pagination: { page: 1, perPage: 500 },
      sort: { field: "first_name", order: "ASC" },
    },
    { staleTime: 300_000 },
  );
  return useMemo(
    () =>
      new Map(
        members.map((member) => [String(member.id), getMemberName(member)]),
      ),
    [members],
  );
};
